module.exports = __webpack_public_path__ + "media/images/recruitment/landing/mv_bg_sp-b161fb97da3547f4176210d659726b57.jpg";